import { IconPropTypes } from '@/legacy/types';

const Tools = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={14}
			height={15}
			fill='none'
			{...props}
		>
			<path
				fill={props.color || 'currentColor'}
				d='M7.018 9.72c0-.094.015-.184.047-.268a.707.707 0 0 1 .165-.241l1.208-1.209a.707.707 0 0 1 .243-.164l.062-.02.001-.002a.756.756 0 0 1 .203-.026c.07 0 .138.009.203.027l.064.02v.002l.063.028h.001a.76.76 0 0 1 .178.135l3.62 3.622a.71.71 0 0 1 .165.241.766.766 0 0 1 .021.47l-.021.063a.71.71 0 0 1-.165.242l-1.209 1.195a.706.706 0 0 1-.241.164.732.732 0 0 1-.267.048.655.655 0 0 1-.452-.16l-.056-.052-3.62-3.607a.71.71 0 0 1-.166-.242.736.736 0 0 1-.047-.267Zm1.113.003 3.228 3.228.82-.82-3.228-3.228-.82.82Zm-7.002 2.393.411.409h.001v.001l.408.41L5.386 9.5V8.68h-.82l-3.437 3.437Zm11.973-6.664a1.87 1.87 0 0 1-.339 1.077l-.076.11-.018.027-1.508-1.508-1.03 1.031-.778-.777L6.22 8.544v1.54l-.007.008-.032.032-3.726 3.711a.738.738 0 0 1-.239.166.707.707 0 0 1-.268.05.721.721 0 0 1-.27-.05.73.73 0 0 1-.243-.166l-1.204-1.19a.735.735 0 0 1-.166-.243.761.761 0 0 1 0-.543v-.002l.028-.063.001-.002a.754.754 0 0 1 .137-.183L4.01 7.831h1.517l.422-.423-2.941-2.943H1.973L0 2.493 1.647.846l.078-.078.02-.02 1.972 1.973v1.034l2.941 2.942 1.995-1.995-1.24-1.241-.08-.078-.019-.02.683-.682H6.628l-.008-.008-.031-.031-.382-.364-.02-.019L8.447 0l.423.423v1.384l.664-.664.019-.018.019.018 2.964 2.936c.191.181.334.391.427.629.092.235.139.483.139.744Z'
			/>
		</svg>
	);
};

export default Tools;
